// extracted by css-extract-rspack-plugin
var _1 = "KxkQsqFQOvUGREmp";
var _2 = "DqcAOZ98etExZJsL";
var _3 = "BUwaNI4bVd8GFepu";
var _4 = "DqcAOZ98etExZJsL";
var _5 = "BUwaNI4bVd8GFepu";
var _6 = "CZxRu6Sgx8U2ieke";
var _7 = "mbsCf2dBvEEg59Pv";
var _8 = "VDl3G4OxW89_jML1";
var _9 = "mbsCf2dBvEEg59Pv";
var _a = "VDl3G4OxW89_jML1";
var _b = "rMusDu9YvEEodLrx";
var _c = "RdJaMzWsHV4p0EWH";
var _d = "Whj3gBOJNsW23fkJ";
var _e = "Whj3gBOJNsW23fkJ";
var _f = "jVlXdHkPTJIbBuXQ";
var _10 = "b1R9NzjFZzU_e3CS";
var _11 = "h1cAUYfTKX4HHEuy";
var _12 = "BSnkPO6RP5MigvXl";
var _13 = "BSnkPO6RP5MigvXl";
var _14 = "EIEYrd160XwI_KPU";
var _15 = "EIEYrd160XwI_KPU";
var _16 = "APhafIkPmQIrHnN0";
var _17 = "APhafIkPmQIrHnN0";
var _18 = "OSgrjBsP8iA3AQ3B";
var _19 = "OSgrjBsP8iA3AQ3B";
var _1a = "FgEc0x3s7r88CCkv";
var _1b = "FgEc0x3s7r88CCkv";
var _1c = "r8jQ0qtGvsqLqnEo";
export { _1 as "bounce", _2 as "competition-box", _3 as "competition-box--top", _4 as "competitionBox", _5 as "competitionBoxTop", _6 as "date", _7 as "draw-box", _8 as "draw-box--results", _9 as "drawBox", _a as "drawBoxResults", _b as "grid", _c as "group", _d as "header-identifier", _e as "headerIdentifier", _f as "image", _10 as "loader", _11 as "loading", _12 as "match-unit", _13 as "matchUnit", _14 as "matches-container", _15 as "matchesContainer", _16 as "scroll-spy", _17 as "scrollSpy", _18 as "sk-bouncedelay", _19 as "skBouncedelay", _1a as "skl-match-group", _1b as "sklMatchGroup", _1c as "tab" }
